/**
 * HR help text for the End of Employment module.
 *
 * The last working date is the field that matters most here: payroll uses it to
 * decide the month in which the employee's final settlement is calculated, and
 * to prorate their last salary. Setting it in a month that is already closed, or
 * in a future month, changes when and how the employee is paid off.
 */

const endOfEmployment = {
  employment_id: "Employee leaving the company.",
  reason_id: "Why the employee is leaving, such as resignation or termination. It appears on end-of-employment reports and can affect rehire eligibility.",
  resignation_date: "The date the employee gave notice. It is used together with the notice period to check whether notice was properly served.",
  last_working_date: "The employee's final working day. Payroll picks up the final settlement in the salary month containing this date and prorates the last month's salary to it, so this date decides both timing and amount.",
  notice_period: "Tick this when the employee served their notice period. Where the employee did not, the company may recover pay in the final settlement.",
  is_final_settlement: "Whether a final settlement should be prepared for this employee. Turning it off leaves the employee unpaid at exit unless it is handled outside the system.",
  is_rehired: "Marks the employee as eligible for rehire, so HR can filter on it later.",
  joining_date: "The employee's original joining date, shown for reference. It sets the service length used for gratuity and settlement.",
  description: "Any note about this exit, kept on the employee's file.",
  replacement: "Who is taking over the employee's responsibilities.",
  has_interview: "Tick this when an exit interview should be recorded for this employee.",
  is_active: "Only active records are processed.",
  file_attachment: "Resignation letter or other supporting document kept on the employee's file.",
  category: "Which part of the exit checklist this item belongs to.",
  name: "Name of this exit checklist item.",
  question_no: "Order in which this question appears in the exit interview.",
  required: "Tick this when the question must be answered before the exit interview can be submitted.",
  type: "What kind of answer this question expects, such as text or a rating.",
  data: "The answer options offered for this question.",
  interview_answer: "The employee's answer is stored with their exit record and feeds the exit-interview reports HR uses to spot patterns in why people leave.",
};

const exitReason = {
  name: "Name of this leaving reason, such as Resignation or Termination. HR picks it when ending an employment and reports group exits by it.",
  description: "Internal note explaining when this reason should be used.",
  is_active: "Only active reasons can be selected on a new end-of-employment record.",
};

const checklist = {
  name: "Name of this exit checklist item, such as Laptop Returned. It must be completed before the exit is closed.",
  category: "Which department or area is responsible for this item, such as IT or Finance.",
  description: "What the responsible person needs to do to clear this item.",
  is_active: "Only active items appear on new exit checklists.",
};

const exitQuestion = {
  name: "The question asked in the exit interview, exactly as the employee will read it.",
  category: "Which section of the exit interview this question belongs to, so related questions are grouped together.",
  question_no: "Order in which this question appears in the exit interview.",
  type: "What kind of answer is expected, such as free text or a choice from a list.",
  data: "The answer options offered, for questions that expect a choice.",
  required: "When ticked, the exit interview cannot be submitted until this question is answered.",
  is_active: "Only active questions appear in new exit interviews.",
  description: "Internal note about this question.",
  interview_answer: "The employee's answer is stored with their exit record and feeds the exit-interview reports HR uses to spot patterns in why people leave.",
};

export const eoeTooltips = { endOfEmployment, exitReason, checklist, exitQuestion };
export default eoeTooltips;
